/**
 * Expired QR Code Page
 */
import React from 'react';
import { useParams } from 'react-router-dom';
import { Clock, QrCode, XCircle } from 'lucide-react';

export default function ExpiredPage() {
  const { shortCode } = useParams<{ shortCode: string }>();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-red-900/50 to-slate-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md text-center">
        {/* Card */}
        <div className="bg-white/10 backdrop-blur-xl rounded-3xl p-8 border border-white/20 shadow-2xl">
          {/* Icon */}
          <div className="flex justify-center mb-6">
            <div className="relative">
              <div className="w-20 h-20 bg-gradient-to-br from-red-500 to-orange-500 rounded-2xl flex items-center justify-center shadow-lg">
                <Clock className="w-10 h-10 text-white" />
              </div>
              <div className="absolute -bottom-2 -right-2 w-8 h-8 bg-white rounded-lg flex items-center justify-center shadow-md">
                <XCircle className="w-5 h-5 text-red-500" />
              </div>
            </div>
          </div>

          {/* Title */}
          <h1 className="text-2xl font-bold text-white mb-2">
            Link Expired
          </h1>
          <p className="text-white/60 mb-6">
            This QR code is no longer active
          </p>

          {/* Info Box */}
          <div className="bg-white/5 rounded-xl p-4 border border-white/10">
            <p className="text-white/50 text-sm">
              The owner of this QR code set it to expire. If you believe this is an error, please contact them directly.
            </p>
          </div>
        </div>

        {/* Footer */}
        <p className="text-white/40 text-center text-sm mt-6">
          Powered by Clinqr
        </p>
      </div>
    </div>
  );
}

